import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Building2, Plus } from 'lucide-react';

import { useLocationsManagement } from './LocationsManagement/useLocationsManagement';
import LocationsList from './LocationsManagement/LocationsList';
import LocationDetail from './LocationsManagement/LocationDetail';
import LocationFormDialog from './LocationsManagement/LocationFormDialog';

export default function LocationsManagement() {
  const f = useLocationsManagement();

  return (
    <div data-testid="locations-page">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-4xl font-black font-heading uppercase">Branch Locations</h1>
        <LocationFormDialog
          isOpen={f.isDialogOpen}
          onOpenChange={f.handleDialogChange}
          editingLocation={f.editingLocation}
          activeTab={f.activeTab}
          onTabChange={f.setActiveTab}
          formData={f.formData}
          onUpdateField={f.updateField}
          onUpdateOperatingHours={f.updateOperatingHours}
          onAddBreak={f.addBreak}
          onUpdateBreakField={f.updateBreakField}
          onRemoveBreak={f.removeBreak}
          onToggleSport={f.toggleSport}
          onToggleAmenity={f.toggleAmenity}
          onSave={f.handleSaveLocation}
          onOpenCreate={f.openCreate}
        />
      </div>

      {f.loading ? (
        <div className="text-center py-8 text-muted-foreground">Loading...</div>
      ) : f.locations.length === 0 ? (
        <Card className="p-8 text-center">
          <Building2 className="w-16 h-16 mx-auto mb-4 text-muted-foreground/50" />
          <p className="text-muted-foreground mb-4">No locations configured yet</p>
          <Button onClick={f.openCreate} className="btn-volt">
            <Plus className="w-5 h-5 mr-2" />
            Add Your First Location
          </Button>
        </Card>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <LocationsList
            locations={f.locations}
            selectedLocation={f.selectedLocation}
            onSelect={f.setSelectedLocation}
          />
          <div className="lg:col-span-2">
            <LocationDetail
              location={f.selectedLocation}
              pricingRules={f.pricingRules}
              onEdit={f.openEdit}
              onDelete={f.handleDeleteLocation}
              onGoPricing={f.goToPricing}
            />
          </div>
        </div>
      )}
    </div>
  );
}
